export default (langStr = {}) => {
  const { en, zhhk } = langStr;

  return zhhk || en || '';
};
